import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';
import { alpha, PaletteColor, useTheme } from '@mui/material/styles';

interface Props extends ChipProps {}

export type BoldChipColors =
  | 'info'
  | 'success'
  | 'primary'
  | 'warning'
  | 'error'
  | 'neutral';

export const BoldChip: React.FC<Props> = props => {
  const theme = useTheme();

  const colorMap: Record<BoldChipColors, PaletteColor> = {
    info: theme.palette.info,
    success: theme.palette.success,
    primary: theme.palette.primary,
    warning: theme.palette.warning,
    neutral: theme.palette.neutral,
    error: theme.palette.error
  };

  const color = props.color
    ? colorMap[props.color as BoldChipColors].main
    : theme.palette.primary.main;

  const modifiedProps: ChipProps = {
    ...props,
    sx: {
      ...(props.sx ?? {}),
      fontWeight: 600,
      backgroundColor: alpha(color, 0.32),
      cursor: 'default',
      height: 28
    }
  };

  return <Chip {...modifiedProps} />;
};
